import $ from 'jquery';
window.$ = window.jQuery = $;

import 'slick-carousel';
$('.promo__slick').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	dots: true,
	infinite: true,
	speed: 1000,
	fade: true,
	autoplay: false,
	autoplaySpeed: 2000,
});


/* Slider progressbar */
var time = 2;
var $slick, isPause, tick, percentTime = 0;
//$('.progressbar').appendTo('.slick-dots li');
$slick = $('.promo__slick');
$slick.on({
	mouseenter: function() {
		isPause = false;
	},
	mouseleave: function() {
		isPause = false;
		startProgressbar();
	},
	mousedown: function() {
		//$rbar.fadeOut('slow');
		percentTime = 0;
	},
});
function startProgressbar() {
	clearTimeout(tick);
	isPause = false;
	tick = setInterval(interval, 20);
	$rbar.fadeIn('slow');
}
var $rbar = $('.line__go');
var rlen = .325 * Math.PI * $rbar.attr('x2');
function interval() {
	if (isPause === false) {
		percentTime += 1 / (time + 0.1);
		$rbar.css({
		strokeDasharray: rlen,
		strokeDashoffset: rlen * (1 - percentTime / 100)
		});
		if (percentTime >= 100) {
		$slick.slick('slickNext');
		percentTime = 0;
		startProgressbar();
		}
	}
}
startProgressbar();
